<template>
  <b-modal ref="EmailUpdate" v-model="ShowModal" id="modal-center" class="modal-validation" size="lg"
    no-close-on-backdrop='true' no-close-on-esc='true' centered hide-header hide-footer>
    <template v-slot:default="">
      <h5><b>Please update your details</b></h5>
      <p>In order to update, we require your email address</p>
      <br/>
      <form name="EmailUpdateForm" data-vv-scope="EmailUpdateForm">
        <div class="form-group">
          <label class="form-control-label">
            Email<span class="text-danger">*</span>
          </label>
          <input type="Email" class="form-control" id="Email" name="Email" placeholder="yourmail@gmail.com"
            autocomplete="off" v-model="vModel.Email" data-vv-as='Email' v-validate="'required|min:10|max:90|email_aus'"
            :class="{'input': true, 'is-danger': errors.has('EmailUpdateForm.Email') }" />
          <div v-show="errors.has('EmailUpdateForm.Email')" class="dialog-danger">
            {{ errors.first('EmailUpdateForm.Email') }}
          </div>
        </div>
        <p><b>A validation email will be sent to you.
          Please validate your email by clicking in the link provided in the email. </b></p>
      </form>
    <br/>
      <div class="modal-button-wrapper">
        <b-button block variant="danger" @click="handleOk">SAVE</b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>
  import CommonService from "../services/common";
  export default {
    name: "DisableButtonDialog",
    props: ["ShowModal"],    
    data() {
      return {
        vModel: {
          Email: null
        }
      }
    },
    methods: {
      handleOk: function (evt) {
        var self = this;
        self.$validator.validateAll("EmailUpdateForm").then(result => {
          if (result) {

            self.$http
              .post("v2/account/email/update", {
                Email: self.vModel.Email,
              })
              .then(
                response => {
                  self.$toastr("success", "Email Updated Successfully.");
                  self.$refs.EmailUpdate.hide();
                  self.$emit('onemailupdated');
                },
                error => {

                }
              );
          }
        });
      }
    }
  };
</script>
